export default __webpack_public_path__ + "static/media/logo-super-bonder.34d5804c.png";